import React, { Component } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { amenitiesDisplayed } from '../../utilities/content/propertyAmenitiesDisplayed'

import yn from 'yn'
import _ from 'lodash'

import CarouselPrev from '../../assets/icons/carousel-prev.svg'
import CarouselNext from '../../assets/icons/carousel-next.svg'

if (yn(process.env.REACT_APP_COMPONENT_PROPERTY_AMENITIES_CAROUSEL)) {
  require('../../styles/css/components/property/bk-flow-property-amenities.css')
}

class BkFlowPropertyAmenities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      renderedAmenities: amenitiesDisplayed.default ? amenitiesDisplayed.default : 10
    }
  }

  handleRenderedAmenities = () => {
    if (window.innerWidth >= 1280) {
      this.setState({
        renderedAmenities: amenitiesDisplayed.desktop ? amenitiesDisplayed.desktop : 9
      })
    } else if (window.innerWidth >= 780) {
      this.setState({
        renderedAmenities: amenitiesDisplayed.tablet ? amenitiesDisplayed.tablet : 7
      })
    } else if (window.innerWidth >= 380) {
      this.setState({
        renderedAmenities: amenitiesDisplayed.mobile ? amenitiesDisplayed.mobile : 4
      })
    } else {
      this.setState({
        renderedAmenities: amenitiesDisplayed.mobileSm ? amenitiesDisplayed.mobileSm : 3
      })
    }
  }

  componentDidMount() {
    this.handleRenderedAmenities()
    window.addEventListener('resize', this.handleRenderedAmenities, true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleRenderedAmenities, true);
  }

  render() {
    const {
      availabilityData,
      configData,
    } = this.props

    const hotelLabels = configData.hotel.labels[0]
    const NextArrow = ({currentSlide, slideCount, children, ...props}) => (
      <img src={CarouselNext} alt={hotelLabels.next ? hotelLabels.next : 'next'} {...props}/>
    )
    const PrevArrow = ({currentSlide, slideCount, children, ...props}) => (
      <img src={CarouselPrev} alt={hotelLabels.previous ? hotelLabels.previous : 'previous'} {...props} />
    )

    const carouselSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: this.state.renderedAmenities,
      slidesToScroll: 1,
      nextArrow: (<NextArrow />),
      prevArrow: (<PrevArrow />)
    }

    let propertyAmenities = []

    if (
      availabilityData &&
      availabilityData[0] &&
      availabilityData[0][0] &&
      availabilityData[0][0].viewExtensions &&
      availabilityData[0][0].viewExtensions.amenities &&
      !_.isEmpty(availabilityData[0][0].viewExtensions.amenities)
    ) {
      propertyAmenities = availabilityData[0][0].viewExtensions.amenities
    }

    let renderPropertyAmenities = []

    for (const amenityKey in propertyAmenities) {
      const currentAmenity = propertyAmenities[amenityKey]

      if (
        currentAmenity.name !== '' &&
        currentAmenity.path !== ''
      ) {
        renderPropertyAmenities.push(
          <div className="bk-flow-property__amenities-entry" key={amenityKey}>
            <img src={currentAmenity.path} alt={currentAmenity.name} />
            <p className="u-remove-margin">{ currentAmenity.name }</p>
          </div>
        )
      }
    }

    return (
      !_.isEmpty(renderPropertyAmenities) ? (
        <div className="bk-flow-property__amenities">
          <h4>{ hotelLabels.allRoomsInclude ? hotelLabels.allRoomsInclude : 'All Rooms Include' }</h4>

          <Slider {...carouselSettings}>
            { renderPropertyAmenities }
          </Slider>
        </div>
      ) : (
        null
      )
    )
  }
}

function mapStateToProps(state) {
  return {
    availabilityData: state.availabilityData.availability,
    configData: state.configData.configuration,
  }
}

export default connect(mapStateToProps, null)(BkFlowPropertyAmenities)



// WEBPACK FOOTER //
// ./src/components/property/BkFlowPropertyAmenities.js